import React  from "react";
export default function Footer() {
    return (
        <footer className="my-3">
           <p className="text-center">Made by 💘 Ganesh <a href="https://www.github.com/ganeshr369/" target="blanck"><i className="fa-brands fa-github text-dark fs-3"></i></a></p> 
        </footer>
    )
}